import axios from 'axios'
const sha1 = require('js-sha1');

export default {
    getRFCs: () => axios.post('rfcs'),
        storeRFC: (data, config = {}) => axios.post('/rfcs/store', data, config),
        getRegimensCatalog: () => axios.post('/rfcs/regimens-catalog'),
        setRfcRegimens: (rfc, regimens = []) => axios.post('/rfcs/set-regimens', { rfc, regimens }),
    deleteRFC: (rfc) => axios.post('/rfcs/delete', 
            {rfc: rfc},
            {headers: {'checksum': sha1(rfc)}}
    ),
    getRFC: (rfc) => axios.post('/rfcs/show', 
            {rfc: rfc},
            {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdiCountsByRfc: (rfc) => axios.post('/rfcs/cfdi-counts',
            {rfc: rfc},
            {headers: {'checksum': sha1(rfc)}}
    ),
}